import { KTIcon } from '../../../../_metronic/helpers'
import { useState } from 'react'
import { ListSearchSubscriptionDate } from './ListSearchSubscriptionDate'
import Swal from 'sweetalert2'
import { useForm } from '../core/FormProvider'

const ListToolbar = () => {

    const [errors, setErrors] = useState<string[]>([])
    const [filterByMonthYear, setFilterByMonthYear] = useState<string>('')
    const { loading, setLoading, getDataSaleSummary } = useForm()

    const summary = async () => {
        setLoading(true)
        await getDataSaleSummary(String(filterByMonthYear))
        setLoading(false)
    }

    const resetData = () => {
        setFilterByMonthYear('');
        setErrors([]);
    
        try {
            summary()
        } catch (error: any) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: error?.response?.data?.message,
                showConfirmButton: true,
            })
        }
    }

    const filterData = () => {
        
        try {
            summary()
        } catch (error: any) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: error?.response?.data?.message,
                showConfirmButton: true,
            })
        }

        const closeButton = document.querySelector<HTMLButtonElement>('#kt_drawer_filter_close');

        if (closeButton) {
            closeButton.click();
        };
    }

    return (
        <>
            <button
                disabled={loading}
                type='button'
                className='btn btn-light-danger me-3'
                id="kt_drawer_filter_button"
            >
                <KTIcon iconName='filter' className='fs-2' />
                Filtrar
            </button>
            <div
                id="kt_drawer_filter"
                className='bg-body'
                data-kt-drawer='true'
                data-kt-drawer-name='activities'
                data-kt-drawer-activate='true'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width="{default:'300px', 'lg': '500px'}"
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle="#kt_drawer_filter_button"
                data-kt-drawer-close="#kt_drawer_filter_close"
            >
                <div className='card shadow-none rounded-0' style={{ width: '100%' }}>
                    <div className='card-header' id='kt_activities_header'>
                        <h3 className='card-title fw-bolder text-dark'>Opções de Filtro</h3>

                        <div className='card-toolbar'>
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-active-light-danger me-n5'
                                id='kt_drawer_filter_close'
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </button>
                        </div>
                    </div>
                    <div className='card-body position-relative' id='kt_activities_body'>

                        <div className='timeline'>
                            <div className='px-7 py-5' data-kt-user-table-filter='form'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <ListSearchSubscriptionDate filterByMonthYear={filterByMonthYear} setFilterByMonthYear={setFilterByMonthYear} setErrors={setErrors} errors={errors} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card-footer py-5 text-center' id='kt_activities_footer'>
                        <div className='d-flex justify-content-end'>
                            <button
                                type='button'
                                disabled={loading}
                                onClick={resetData}
                                className='btn btn-secondary fw-bold me-2 px-6'
                                data-kt-menu-dismiss='true'
                                data-kt-user-table-filter='reset'
                            >
                                Limpar
                            </button>
                            <button
                                disabled={loading || (errors?.[0]?.length || errors?.[1]?.length) ? true : false}
                                type='button'
                                onClick={filterData}
                                className='btn btn-danger fw-bold px-6'
                                data-kt-menu-dismiss='true'
                                data-kt-user-table-filter='filter'
                            >
                                Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export { ListToolbar }
